import { t } from '../services/language-manager';
import logo from '../assets/mediabriz-logo-svg-400px.svg';

interface SignInPageProps {
  onSignIn: () => void;
  busy?: boolean;
}

/**
 * Embedded Apps iframe: Genesys login must open in a popup, and browsers often
 * block window.open unless it runs from a click. This page is that click.
 */
export function SignInPage({ onSignIn, busy }: SignInPageProps) {
  return (
    <div className="card" style={{ textAlign: 'center' }}>
      <img src={logo} alt="Mediabriz" className="wizard-header__logo" style={{ height: '56px', marginBottom: '16px' }} />
      <div className="card__title">{t('signin-title')}</div>

      <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: '20px 0 24px' }}>
        {t('signin-help')}
      </p>

      <div className="btn-group" style={{ justifyContent: 'center' }}>
        <button className="btn btn--primary" type="button" onClick={onSignIn} disabled={busy}>
          {busy ? t('loading-authenticating') : t('signin-button')}
        </button>
      </div>
    </div>
  );
}
